<template>
  <modal
    :value="show"
    max-width="fit-content"
    content-class="modal modal-round access-point-controller-create"
  >
    <div class="close" @click="closeModal">&times;</div>

    <app-button
      v-if="!noActivator"
      class="access-point-controller-create-activator btn btn-primary_bottom"
      slot="activator"
      :label="$t('message.spots.message.registerNewController')"
      icon="plus-circle-outline"
      flat
      underline
      primary
      @click="openModalAndReset"
    >
    </app-button>

    <form
      class="access-point-controller-form card-body"
      :class="{ 'access-point-controller-form_edit': isEdit }"
    >
      <button
        v-if="step > 1 && !isEdit"
        type="button"
        class="access-point-controller-form-return"
        @click="goBackOneStep"
      >
        <i class="mdi mdi-arrow-left pointer"></i>
      </button>
      <v-stepper v-model="step" class="stepper" alt-labels>
        <v-stepper-header class="stepper-header">
          <v-stepper-step
            class="stepper-header-step"
            :complete="step > 1"
            step="1"
            @click="selectStep(1)"
          >
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            class="stepper-header-step"
            :complete="step > 2"
            step="2"
            @click="selectStep(2)"
          >
          </v-stepper-step>
        </v-stepper-header>

        <h1 class="text-center text-heading">
          <strong>
            {{ isEdit ? "Editar Controladora" : "Nova Controladora" }}
          </strong>
        </h1>

        <v-stepper-items class="stepper-items">
          <v-stepper-content step="1">
            <div class="cards-wrapper">
              <card-select
                :options="controlTypes"
                @selected="setControllerType"
              />
            </div>
          </v-stepper-content>

          <v-stepper-content step="2">
              <template v-if="step === 2">
                  <div class="form-body">
                      <v-text-field
                          ref="firstInput"
                          :label="$t('message.generics.message.name')"
                          :name="$t('message.generics.message.name')"
                          v-validate="'required'"
                          :error-messages="errors.collect($t('message.generics.message.name'))"
                          v-model="form.name"
                      />

                      <!-- MERAKI -->
                      <template v-if="isMerakiControllerForm">
                          <v-text-field
                              label="Chave de API"
                              name="Chave de API"
                              v-validate="'required'"
                              :error-messages="errors.collect('Chave de API')"
                              v-model="form.authorizationHash"
                          />
                      </template>

                      <!-- HUAWEI -->
                      <template v-else-if="isHuaweiControllerForm">
                          <v-text-field
                              label="Login"
                              name="Login"
                              v-validate="'required'"
                              :error-messages="errors.collect('Login')"
                              v-model="form.username"
                          />
                          <v-text-field
                              label="Senha"
                              name="Senha"
                              v-validate="'required'"
                              :error-messages="errors.collect('Senha')"
                              v-model="form.password"
                          />
                      </template>

                      <!-- TP-LINK -->
                      <template v-else-if="isTpLinkControllerForm">
                          <v-text-field
                              :label="$t('message.spots.message.login')"
                              :name="$t('message.spots.message.login')"
                              v-validate="'required'"
                              :error-messages="errors.collect($t('message.spots.message.login'))"
                              v-model="form.username"
                          />
                          <v-text-field
                              :label="$t('message.spots.message.password')"
                              name="Senha"
                              type="password"
                              :error-messages="errors.collect($t('message.spots.message.password'))"
                              v-model="form.password"
                          />
                          <v-text-field
                              :label="$t('message.spots.message.domain')"
                              name="Domínio"
                              v-validate="'required'"
                              :error-messages="errors.collect($t('message.spots.message.domain'))"
                              v-model="form.domain"
                          />
                          <v-text-field
                              :label="$t('message.spots.message.port')"
                              :name="$t('message.spots.message.port')"
                              type="number"
                              v-validate="'required'"
                              :error-messages="errors.collect($t('message.spots.message.port'))"
                              v-model="form.port"
                          />
                          <v-text-field
                              :label="$t('message.spots.message.siteId')"
                              :name="$t('message.spots.message.siteId')"
                              v-validate="'required'"
                              :error-messages="errors.collect($t('message.spots.message.siteId'))"
                              v-model="form.controllerSiteId"
                          />
                          <checkbox
                              class="checkbox-controller"
                              v-model="form.controllerDefault"
                              :label="$t('message.spots.message.setDefaultController')"
                          />
                      </template>

                      <!-- Outros (UNIFI etc.) -->
                      <template v-else>
                          <v-text-field
                              :label="$t('message.spots.message.login')"
                              :name="$t('message.spots.message.login')"
                              v-validate="'required'"
                              :error-messages="errors.collect($t('message.spots.message.login'))"
                              v-model="form.username"
                          />
                          <v-text-field
                              :label="$t('message.spots.message.password')"
                              name="Senha"
                              type="password"
                              :error-messages="errors.collect($t('message.spots.message.password'))"
                              v-model="form.password"
                          />
                          <v-text-field
                              :label="$t('message.spots.message.domain')"
                              name="Domínio"
                              v-validate="'required'"
                              :error-messages="errors.collect($t('message.spots.message.domain'))"
                              v-model="form.domain"
                          />
                          <v-text-field
                              :label="$t('message.spots.message.port')"
                              :name="$t('message.spots.message.port')"
                              type="number"
                              v-validate="'required'"
                              :error-messages="errors.collect($t('message.spots.message.port'))"
                              v-model="form.port"
                          />
                          <v-text-field
                              :label="$t('message.spots.message.domainFailover')"
                              :name="$t('message.spots.message.domainFailover')"
                              v-validate="form.portFailover ? 'required' : undefined"
                              :error-messages="errors.collect($t('message.spots.message.domainFailover'))"
                              v-model="form.domainFailover"
                          />
                          <v-text-field
                              :label="$t('message.spots.message.portFailover')"
                              :name="$t('message.spots.message.portFailover')"
                              type="number"
                              v-validate="form.domainFailover ? 'required' : undefined"
                              :error-messages="errors.collect($t('message.spots.message.portFailover'))"
                              v-model="form.portFailover"
                          />
                          <checkbox
                              class="checkbox-controller"
                              v-model="form.controllerDefault"
                              :label="$t('message.spots.message.setDefaultController')"
                          />
                      </template>
                  </div>
              </template>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </form>
    <template v-if="step === 2" #footer>
      <div class="card-footer">
        <button
          type="button"
          class="btn btn-primary btn-round"
          @click="validate()"
        >
          {{ $t("message.generics.message.save") }}
        </button>
        <button
          v-if="!isMerakiControllerForm && !isHuaweiControllerForm"
          type="button"
          class="btn btn-secondary btn-round"
          @click="test()"
        >
          {{ $t("message.generics.message.test") }}
        </button>
        <button
          v-if="!isMerakiControllerForm && !isTpLinkControllerForm && !isHuaweiControllerForm"
          type="button"
          class="btn btn-secondary btn-round"
          @click="testFailover()"
        >
          {{ $t("message.spots.message.testFailover") }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import AppButton from "@/components/generic/button/Button";
import Checkbox from "@components/Checkbox";
import CardSelect from "@components/form/CardSelect";
import EventBus from "@packages/event-bus/index";

export default {
  components: {
    Checkbox,
    AppButton,
    Modal,
    CardSelect,
  },

  data() {
    return {
      step: 1,
      controlTypes: [],
      show: false,
      form: {
        name: undefined,
        username: undefined,
        password: null,
        domain: undefined,
        port: undefined,
        domainFailover: undefined,
        portFailover: undefined,
        controllerDefault: false,
        type: undefined,
        authorizationHash: undefined,
        controllerSiteId: undefined,
      },
    };
  },

  props: {
    item: {
      type: Object,
    },
    manualShow: {
      type: Boolean,
      default: false,
    },
    noActivator: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isEdit() {
      return !!this.item;
    },
    isMerakiControllerForm() {
      return this.form.type === "CISCO_MERAKI";
    },
    isHuaweiControllerForm() {
      return this.form.type === "HUAWEI_IMASTER";
    },
    isTpLinkControllerForm() {
        return this.form.type === "OMADA_SOFTWARE";
    },
  },

  watch: {
    manualShow(showVal) {
      this.show = showVal;

      if (this.show) {
        this.reset();
      }
    },
    show() {
      this.$emit("on-handle-list-show");
    },
  },

  methods: {
    selectStep(step) {
      if (this.isEdit) return;
      if (this.step === 1 && !this.form.type) {
        return EventBus.$emit("show-message", {
          type: "ERROR",
          message: "É necessário escolher o tipo de controladora",
        });
      }
      this.step = step;
    },
    goBackOneStep() {
      this.step -= 1;
    },
    openModalAndReset() {
      this.show = true;

      this.reset();
    },
    closeModal() {
      this.show = false;
      this.$emit("closed");
    },
    onInput() {
      if (this.show) {
        this.$nextTick(() => {
          this.$refs.firstInput.focus();
        });
      } else {
        this.$emit("closed");
      }
    },
    async reset() {
      if (this.item) {
        this.step = 2;
        this.form = {
          name: this.item.name,
          username: this.item.username,
          password: this.item.password,
          domain: this.item.domain,
          port: this.item.port,
          domainFailover: this.item.domainFailover,
          portFailover: this.item.portFailover,
          controllerDefault: this.item.controllerDefault,
          type: this.item.type,
          authorizationHash: this.item.authorizationHash,
          controllerSiteId: this.item.controllerSiteId,
        };
      } else {
        this.step = 1;
        this.form = {
          name: undefined,
          username: undefined,
          password: null,
          domain: undefined,
          port: undefined,
          domainFailover: undefined,
          portFailover: undefined,
          controllerDefault: false,
          type: undefined,
          authorizationHash: undefined,
          controllerSiteId: undefined,
        };

        this.$validator.reset();
      }
      await this.setDeviceTypes();
    },
    async validate() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        this.save();
      }
    },
    async setDeviceTypes() {
      try {
        const controllerTypes =
          await this.$api.core.accessPoint.controller.types();

        const controllerImageMap = {
              CISCO_MERAKI: "cisco-meraki.png",
              OMADA_SOFTWARE: "omada.svg",
              HUAWEI_IMASTER: "huawei.svg"
          };

        this.controlTypes = Object.entries(controllerTypes).map(
          ([type, text]) => {
            return {
              value: type,
              text,
              image: `images/devices-logo/${controllerImageMap[type] || "unifi.svg"}`,
              imageStyle: { height: "40px" },
              selectable: true
            };
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      EventBus.$emit("SHOW_SPINNER");

      try {
        if (this.item) {
          await this.$api.core.accessPoint.controller.edit({
            controllerId: this.item.id,
            ...this.form,
          });
        } else {
          await this.$api.core.accessPoint.controller.create({
            ...this.form,
          });
        }

        this.show = false;

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t("message.successMessages.message.recordSaved"),
        });

        this.$emit("submit");
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    async test() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        EventBus.$emit("SHOW_SPINNER");

        try {
          await this.$api.core.accessPoint.controller.test({
            id: this.item ? this.item.id : null,
            ...this.form,
          });
        } catch (error) {
          console.log(error);
        } finally {
          EventBus.$emit("CANCEL_SPINNER");
        }
      }
    },
    async testFailover() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        EventBus.$emit("SHOW_SPINNER");

        try {
          await this.$api.core.accessPoint.controller.testFailover({
            id: this.item ? this.item.id : null,
            ...this.form,
          });
        } catch (error) {
          console.log(error);
        } finally {
          EventBus.$emit("CANCEL_SPINNER");
        }
      }
    },
    setControllerType(type) {
      this.form.type = type;
      this.step++;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.access-point-controller-create-activator {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-left: 25px;

  .access-point-controller-create-activator-icon {
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
}

.access-point-controller-form {
  .access-point-controller-form-return {
    position: absolute;
    top: 32px;
    left: 20px;
    z-index: 100;
    color: $primary;

    i {
      font-size: 30px;
    }
  }

  .stepper {
    .stepper-header {
      padding: 0 5%;

      .v-divider {
        margin-top: 11px;
      }
      .stepper-header-step {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    h1 {
      margin-bottom: 0;
    }
    .stepper-items {
      .cards-wrapper {
        padding-top: 18px;
      }
      ::v-deep .v-stepper__content {
        padding: 0;
      }
      .form-body {
        .checkbox-controller {
          margin-top: 13px;
        }
      }
    }
  }
}

.btn {
  margin-right: 10px;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.modal-round .v-card .card-body {
  min-height: 160px;
  overflow-x: hidden;
}
</style>
